import { cn } from 'lib/utils';

export type SpacerProps = {
  className?: string;
  variant?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};

/* All clamps share a range of 400-1440px */
const spacerVariantClasses = {
  xs: 'h-[clamp(1.5rem,1.115rem+1.538vw,2.5rem)]', // 24-40
  sm: 'h-[clamp(3rem,2.231rem+3.077vw,5rem)]', // 48-80
  md: 'h-[clamp(5rem,4.038rem+3.846vw,7.5rem)]', // 80-120
  lg: 'h-[clamp(6.25rem,4.808rem+5.769vw,10rem)]', // 100-160
  xl: 'h-[clamp(7rem,5.462rem+6.154vw,11rem)]', // 112-176
};

const Spacer = ({ className, variant = 'md' }: SpacerProps) => (
  <div
    className={cn('w-full', spacerVariantClasses[variant], className)}
    aria-hidden="true"
  />
);

export default Spacer;
